import { ExportQSetFormat } from '@exam-management/graphql';

export enum QSetExportFileTemplate {
  QUESTION_WITH_CHOICES = 'QUESTION_WITH_CHOICES',
  QUESTION_WITH_CHOICES_AND_SOLUTION = 'QUESTION_WITH_CHOICES_AND_SOLUTION',
}

export const QSET_EXPORT_FILE_TYPE_OPTIONS = [
  {
    label: 'PDF (.pdf)',
    value: ExportQSetFormat.Pdf,
  },
  {
    label: 'Microsoft Word (.docx)',
    value: ExportQSetFormat.Docx,
  },
];

export const QSET_EXPORT_FILE_TEMPLATE_OPTIONS = [
  {
    label: 'โจทย์, ตัวเลือก',
    value: QSetExportFileTemplate.QUESTION_WITH_CHOICES,
  },
  {
    label: 'โจทย์, ตัวเลือก, และเฉลย',
    value: QSetExportFileTemplate.QUESTION_WITH_CHOICES_AND_SOLUTION,
  },
];

export { ExportQSetFormat };
